import { topliApi } from '@/shared/api/topli/TopliApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { unitAmenityListByPageQueryKey } from '@/entities/UnitAmenity'

export const deleteUnitAmenity = async (unitAmenityId: number) => {
  const response = await topliApi.unitAmenity.delete(unitAmenityId)
  return response
}

export const useDeleteUnitAmenityApi = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => deleteUnitAmenity(id),
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: [unitAmenityListByPageQueryKey],
        refetchType: 'active',
      })
    },
  })
}
